<footer class="footer">
  <p class="text">© {{ year }} The lift consultancy</p>
</footer>
